import React from 'react';
import { Global } from '@emotion/react'
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"

import globalStyles from './global-styles';

import theme, { MediaContextProvider } from './theme';

const ReThemeProvider = ({ children }) => (
  <ChakraProvider theme={theme} resetCSS>
    <MediaContextProvider>
      <>
        <ColorModeScript initialColorMode="light" />
        <Global styles={globalStyles} />
        {children}
      </>
    </MediaContextProvider>
  </ChakraProvider>
);

export default ReThemeProvider
